<template>
  <!-- placeholder -->
  <div v-if="loading" class="mt-1 mb-4" aria-hidden="true">
    <div v-for="n in 3" :key="n" class="row py-2 row_detail placeholder-glow">
      <div data-descr="галочка" class="col col-2 order-1 col-sm-1 order-sm-1">
        <span class="placeholder placeholder-lg col-4"></span>
      </div>
      <div data-descr="описание" class="col col-7 order-5 col-sm-7 order-sm-3 col-md-4 col-xl-5 mb-2">
        <span class="placeholder col-12 bg-info"></span>
        <!-- туть -->
        <span class="placeholder col-7"></span>
        <span class="placeholder col-4"></span>
        <span class="placeholder col-4"></span>
        <span class="placeholder col-6"></span>
        <span class="placeholder col-8"></span>
      </div>
      <div data-descr="фотки" class="col col-4 order-4 col-sm-3 offset-sm-0 order-sm-2 col-md-3 col-lg-3 col-xl-2">
        <span class="placeholder col-12"><br /><br /><br /><br /></span>
      </div>
      <div data-descr="цена" class="col col-8 order-2 col-sm-10 order-sm-4 col-md-3 col-lg-3 text-right prices">
        <span class="placeholder col-12"></span>
      </div>
      <div data-descr="кнопка" class="col col-2 order-3 col-sm-2 order-sm-5 col-md-1">
        <!-- туть -->
      </div>
    </div>
  </div>
  <div v-else-if="error" class="alert alert-warning" role="alert">{{ msgError }}</div>
  <div v-else>
    <catalog-row v-for="item in items" :key="item.strcode" :item="item" :cart="cart"></catalog-row>

    <div v-if="onpage < total && (page + 1) * onpage < total" class="my-3 text-center">
      <div v-if="loadingmore" class="progress">
        <div
          class="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          :aria-valuenow="progress"
          aria-valuemin="0"
          aria-valuemax="100"
          :style="`width: ${progress}%`"></div>
      </div>
      <button-load-more v-else :page="page" :onpage="onpage" :total="total" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import ButtonLoadMore from './button-loadmore.vue';
import CatalogRow from './catalog-row.vue';

export default {
  name: 'CatalogSearchResult',
  components: {
    ButtonLoadMore,
    CatalogRow,
  },
  props: {
    cart: {
      type: Object,
      default() {
        return {};
      },
      required: true,
    },
  },
  data: function () {
    return {
      loading: true,
      error: false,
      loadingmore: false,
      //
      search: '',
      searching: false,
      minlength: 5,
      //
      items: [],
      msgError: '',
      // страницы
      page: 0,
      onpage: 25,
      total: 0,
      //
      progress: 0,
    };
  },
  methods: {
    doSearch: function () {
      if (this.searching == true) {
        return;
      }

      this.error = false;
      this.msgError = '';
      this.searching = true;

      // что искать
      let s = null;
      s = localStorage.getItem('search');
      if (s === null) {
        // нет кода для поиска
        this.error = true;
        this.msgError =
          'Для поиска требуется указать код производителя (не меньше ' + this.minlength + ' символов) или артикул.';
        this.searching = false;

        this.$bs5utils.Snack.show(
          'warning',
          'Невозможно выполнить поиск, нужно указать код производителя или артикул товара.',
          this.$store.getters.delay.warning
        );
        return;
      }

      this.search = s;

      if (this.search.length == 0) {
        this.error = true;
        this.msgError =
          'Для поиска требуется указать код производителя (не меньше ' + this.minlength + ' символов) или артикул.';
        this.searching = false;

        this.$bs5utils.Snack.show(
          'warning',
          'Невозможно выполнить поиск, нужно указать код производителя или артикул товара.',
          this.$store.getters.delay.warning
        );
      }

      if (this.search.length < this.minlength) {
        this.error = true;
        this.msgError = 'Для поиска введите не меньше ' + this.minlength + ' символов.';
        this.searching = false;

        this.$bs5utils.Snack.show(
          'warning',
          'Для поиска нужно указать минимум ' + this.minlength + ' символов.',
          this.$store.getters.delay.warning
        );
        return;
      }

      this.loading = true;

      axios
        .get(`${this.$store.getters.urlsearch}/${this.search}?onpage=${this.onpage}`)
        .then((res) => {
          const { data } = res;

          this.items = data.data;

          this.page = data.current_page;
          this.onpage = data.per_page;
          this.total = data.total;

          setTimeout(() => {
            this.$root.$emit('cart-sync', {});
          }, 150);
        })
        .catch((err) => {
          this.items = [];
          this.page = 0;

          this.error = true;
          this.msgError = err.response.data?.message ?? err.message;
          // console.error(err);
        })
        .finally(() => {
          setTimeout(() => {
            this.searching = false;
            this.loading = false;
          }, 150);
        });
    },
    loadMore: function () {
      if (this.searching == true) {
        return;
      }

      this.searching = true;

      if (this.search.length < this.minlength) {
        this.error = true;
        this.msgError = 'Для поиска введите не меньше ' + this.minlength + ' символов.';
        this.searching = false;

        this.$bs5utils.Snack.show(
          'warning',
          'Для поиска нужно указать минимум ' + this.minlength + ' символа.',
          this.$store.getters.delay.warning
        );
        return;
      }

      this.progress = 0;
      const p = setInterval(() => {
        this.progress++;
        if (p == 100) {
          clearInterval(p);
        }
      }, 500);

      this.loadingmore = true;
      this.page = this.page + 1;

      axios
        .get(`${this.$store.getters.urlsearch}/${this.search}?page=${this.page}&onpage=${this.onpage}`)
        .then((res) => {
          const { data } = res;

          this.items = this.items.concat(data.data);

          this.page = data.page;
          this.onpage = data.per_page;
          this.total = data.total;

          setTimeout(() => {
            this.$root.$emit('cart-sync', {});
          }, 150);
        })
        .catch((err) => {
          this.items = [];
          this.page = 0;

          this.error = true;
          this.msgError = err.response.data?.message ?? err.message;
          // console.error(err);
        })
        .finally(() => {
          setTimeout(() => {
            this.searching = false;
            this.loadingmore = false;
          }, 150);

          clearInterval(p);
        });
    },
  },
  created() {
    // сообщаем, что на странице поиска
    this.$root.$emit('page-search', {});

    // поискать
    this.$root.$on('do-search', () => {
      this.doSearch();
    });
  },
  mounted() {
    this.$root.$on('load-more', () => {
      this.loadMore();
    });
  },
};
</script>

<style scoped>
.progress {
  width: 50%;
  margin-left: 25%;
}
</style>
